import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";

import { getManureAdditives, getManureAdditivesAdmin } from "services";

import { getEnvironment, injectNames } from "utils";

import { DEFAULT_CACHE_TIME, GET_MANURE_ADDITIVES } from "consts";

import { ManureAdditive } from "models";

export const useGetManureAdditives = () => {
  // Not having { useSuspense: false } caused unintended UI behavior — like a drawer opening and closing on mount,
  // due to remounting triggered by Suspense fallback.
  // DO NOT REMOVE unless you're explicitly handling Suspense with fallback UIs.
  const { t } = useTranslation("footprinting", { useSuspense: false });
  const isAdmin = getEnvironment().admin;

  // Translate in select, not queryFn, so the cached data stays language-neutral and names follow language and namespace loads.
  const withTranslatedNames = useCallback((manureAdditives: ManureAdditive[]) => injectNames(manureAdditives, t, "manureAdditives"), [t]);

  return useQuery({
    queryKey: [GET_MANURE_ADDITIVES, isAdmin],
    queryFn: () => (isAdmin ? getManureAdditivesAdmin() : getManureAdditives()),
    select: withTranslatedNames,
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
};
